var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.puchipuchi_een{fill:#111918;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "puchipuchi_een",
    d: "M1,24c0,1.1,0.9,2,2,2h26c1.1,0,2-0.9,2-2V12H1V24z M4,19h12c0.552,0,1,0.448,1,1s-0.448,1-1,1H4 c-0.552,0-1-0.448-1-1S3.448,19,4,19z M4,22h5c0.552,0,1,0.448,1,1s-0.448,1-1,1H4c-0.552,0-1-0.448-1-1S3.448,22,4,22z M31,8v1H1V8 c0-1.1,0.9-2,2-2h26C30.1,6,31,6.9,31,8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalary);
export default __webpack_public_path__ + "static/media/salary.766124f34c1972fe172d85cc999b977a.svg";
export { ForwardRef as ReactComponent };